import React, { useEffect, useState, useRef, useCallback } from "react";
import ReactDOM from "react-dom";
import ImageContainer from "../../../layouts/ImageContainer";
import { gallery_styles } from "../../../utils/gallery.js";
import { modalEventListener } from "../../../utils/ModalEventListener";
import { axios_instance } from "../../../api/axios_instance.js";
import { formatAmount } from "../../../utils/format.js";
import ContainerLoading from "../../../layouts/ContainerLoading.jsx";
import {
  decryptRequest,
  encryptRequest,
} from "../../../utils/encryptdecryptrequest.js";
import ModalWrapper from "../../../layouts/ModalWrapper";

const GalleryModal = ({
  galleryModalProps,
  closeGalleryModal,
  showGalleryModal,
}) => {
  const {
    finance_lead_id,
    name,
    last_name,
    bank_name,
    regno,
    current_balance,
  } = galleryModalProps;

  const initialState = {
    docContIdx: [0, 0],
    rotation1: 0,
    rotation2: 0,
    showScroll: false,
    documents: [],
  };

  const [state, setState] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);

  const ref = useRef();

  useEffect(() => {
    return modalEventListener(ref, closeGalleryModal);
  }, [closeGalleryModal]);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const reqData = encryptRequest({
        loan_id: finance_lead_id,
        isPaymentRequested: "",
        isPrePaymentRaised: "",
        dis_id: "",
        source: "withheldPanel",
      });
      let docs_response = await axios_instance({
        url: "/dts/getImageList",
        method: "POST",
        data: { reqData },
      });
      docs_response = decryptRequest(docs_response.data.resData);

      setState((prevState) => ({
        ...prevState,
        documents: docs_response.documents,
      }));
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [finance_lead_id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const onDocumentChange = async (e, idx) => {
    const docContIdx = state.docContIdx;
    docContIdx[idx] = parseInt(e.target.value);
    setState({ ...state, docContIdx: [...docContIdx] });
  };

  const prevDoc = async (idx) => {
    const docContIdx = state.docContIdx;
    docContIdx[idx] =
      docContIdx[idx] > 0 ? docContIdx[idx] - 1 : state.documents.length - 1;
    setState({ ...state, docContIdx: [...docContIdx] });
  };

  const nextDoc = async (idx) => {
    const docContIdx = state.docContIdx;
    docContIdx[idx] =
      docContIdx[idx] < state.documents.length - 1 ? docContIdx[idx] + 1 : 0;
    setState({ ...state, docContIdx: [...docContIdx] });
  };

  const rotate = (id) => {
    if (state[`rotation${id}`] === 3) {
      setState({ ...state, [`rotation${id}`]: 0 });
    } else {
      setState({
        ...state,
        [`rotation${id}`]: state[`rotation${id}`] + 1,
      });
    }
  };

  return ReactDOM.createPortal(
    <ModalWrapper show={showGalleryModal} onClose={closeGalleryModal}>
      <div className="modal-wrapper">
        <style>{gallery_styles}</style>
        <div className="gallery-modal-content" ref={ref}>
          <div className="modal-header">
            <button type="button" className="close" onClick={closeGalleryModal}>
              <span>&times;</span>
            </button>
            <h4 className="modal-title" id="">
              Gallery
            </h4>
          </div>

          <div className="modal-body clearfix">
            <div id="withheld_gallery_header">
              <div className="row">
                <div className="col-md-12 pad-R5 fx-full-col">
                  <div className="col-md-3 ">
                    <div className="form-group ">
                      <span className="caseTxt">Reg No.</span>
                      <div className="casedetailTxt largeTxt" id="gal_regno">
                        {regno}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <div className="form-group ">
                      <span className="caseTxt">Customer Name</span>
                      <div className="casedetailTxt largeTxt" id="gal_name">
                        {`${name} ${last_name}`}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <div className="form-group ">
                      <span className="caseTxt">Disbursing Bank</span>
                      <div className="casedetailTxt largeTxt" id="gal_bank">
                        {bank_name}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <div className="form-group ">
                      <span className="caseTxt">Ledger Balance</span>
                      <div
                        className={`casedetailTxt largeTxt ${
                          !current_balance || current_balance < 0
                            ? "col-red"
                            : "col-green"
                        }`}
                        id="gal_balance"
                      >
                        <span className="fa fa-inr"></span>
                        {formatAmount(current_balance)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12" id="dt-docs-view">
              <div className="row">
                <div className="col-md-12" id="withheld_gallery">
                  <div className="row">
                    <div className="col-md-6">
                      {!isLoading ? (
                        <ImageContainer
                          step={4}
                          id={1}
                          onDocumentChange={(e) => onDocumentChange(e, 0)}
                          documents={state.documents}
                          docSelected={state.docContIdx[0]}
                          rotate={rotate}
                          rotationId={state.rotation1}
                          prevDoc={prevDoc}
                          nextDoc={nextDoc}
                          canScroll={false}
                          enableScroll={() => {}}
                          showScroll={state.showScroll}
                          handleImageError={() => {}}
                          hideAddedDate={true}
                        />
                      ) : (
                        <ContainerLoading galleryLoader={true} />
                      )}
                    </div>
                    <div className="col-md-6">
                      {!isLoading ? (
                        <ImageContainer
                          step={4}
                          id={2}
                          onDocumentChange={(e) => onDocumentChange(e, 1)}
                          documents={state.documents}
                          docSelected={state.docContIdx[1]}
                          rotate={rotate}
                          rotationId={state.rotation2}
                          prevDoc={prevDoc}
                          nextDoc={nextDoc}
                          canScroll={false}
                          enableScroll={() => {}}
                          showScroll={state.showScroll}
                          handleImageError={() => {}}
                          hideAddedDate={true}
                        />
                      ) : (
                        <ContainerLoading galleryLoader={true} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalWrapper>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default GalleryModal;
